import React, { useState, useEffect, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import UserService from "services/UserService";

import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import { getSite } from "services/ConfigServices";
import {
  dtwalltype, dtwallisolation, dtpinionisolation, dtmainthermicalisolation, 
  dtwoodsthermicaltreatment, dtrooftype,dtroofthermicaltreatment,
  dtfloortype, dtfloortisolation
} from "variables/lists/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { batiment } from "variables/patrimoine.js";
import { NotificationManager } from 'react-notifications';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


export default function TertiaryBill(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [walltype, setWalltype] = useState("");
  const [wallisolation, setWallisolation] = useState("");
  const [pinionisolation, setPinionisolation] = useState("");
  const [mainthermicalisolation, setMainthermicalisolation] = useState("");
  const [woodsthermicaltreatment, setWoodsthermicaltreatment] = useState("");
  const [rooftype, setRooftype] = useState("");
  const [roofthermicaltreatment, setRoofthermicaltreatment] = useState("");
  const [floortype, setFloortype] = useState("");
  const [floortisolation, setFloortisolation] = useState("");

  const handleWalltypeChange = (event) => { setWalltype(event.target.value); };
  const handleWallisolationChange = (event) => { setWallisolation(event.target.value); };
  const handlePinionisolationChange = (event) => { setPinionisolation(event.target.value); };
  const handleMainthermicalisolationChange = (event) => { setMainthermicalisolation(event.target.value); };
  const handleWoodsthermicaltreatmentChange = (event) => { setWoodsthermicaltreatment(event.target.value); };
  const handleRooftypeChange = (event) => { setRooftype(event.target.value); };
  const handleRoofthermicaltreatmentChange = (event) => { setRoofthermicaltreatment(event.target.value); };
  const handleFloortypeChange = (event) => { setFloortype(event.target.value); };
  const handleFloortisolationChange = (event) => { setFloortisolation(event.target.value); };



  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "structure.tertiarybill"),
        {
          walltype,
          wallisolation,
          pinionisolation,
          mainthermicalisolation,
          woodsthermicaltreatment,
          rooftype,
          roofthermicaltreatment,
          floortype,
          floortisolation,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "structure.tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setWalltype(res.data.detail.structure?.tertiarybill?.walltype);
        setWallisolation(res.data.detail.structure?.tertiarybill?.wallisolation);
        setPinionisolation(res.data.detail.structure?.tertiarybill?.pinionisolation);
        setMainthermicalisolation(res.data.detail.structure?.tertiarybill?.mainthermicalisolation);
        setWoodsthermicaltreatment(res.data.detail.structure?.tertiarybill?.woodsthermicaltreatment);
        setRooftype(res.data.detail.structure?.tertiarybill?.rooftype);
        setRoofthermicaltreatment(res.data.detail.structure?.tertiarybill?.roofthermicaltreatment);
        setFloortype(res.data.detail.structure?.tertiarybill?.floortype);
        setFloortisolation(res.data.detail.structure?.tertiarybill?.floortisolation);
      });
  }, []);

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ margin: "1.3rem 0rem" }}>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.walltype}
                selectValue={walltype}
                handleSelectValueChange={handleWalltypeChange}
                data={dtwalltype}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.wallisolation}
                selectValue={wallisolation}
                handleSelectValueChange={handleWallisolationChange}
                data={dtwallisolation}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.pinionisolation}
                selectValue={pinionisolation}
                handleSelectValueChange={handlePinionisolationChange}
                data={dtpinionisolation}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.mainthermicalisolation}
                selectValue={mainthermicalisolation}
                handleSelectValueChange={handleMainthermicalisolationChange}
                data={dtmainthermicalisolation}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.woodsthermicaltreatment}
                selectValue={woodsthermicaltreatment}
                handleSelectValueChange={handleWoodsthermicaltreatmentChange}
                data={dtwoodsthermicaltreatment}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.rooftype}
                selectValue={rooftype}
                handleSelectValueChange={handleRooftypeChange}
                data={dtrooftype}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.roofthermicaltreatment}
                selectValue={roofthermicaltreatment}
                handleSelectValueChange={handleRoofthermicaltreatmentChange}
                data={dtroofthermicaltreatment}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.floortype}
                selectValue={floortype}
                handleSelectValueChange={handleFloortypeChange}
                data={dtfloortype}
                disabled={!realestateupdate}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={batiment.structure.tertiarybill.floortisolation}
                selectValue={floortisolation}
                handleSelectValueChange={handleFloortisolationChange}
                data={dtfloortisolation}
                disabled={!realestateupdate}
              />
            </div>
          </div>

        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}
